<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="use1">
        <input type="checkbox" class="custom-control-input mgntp10" id="use1" value="hgHomeuse.use1"
          name="home_use" [(ngModel)]="hgHomeuse.use1" (ngModelChange)="getHome_use('I live there (primary residence)', hgHomeuse.use1)" />
        <label class="custom-control-label font20" for="use1">I live there (primary residence)</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use2">
        <input type="checkbox" class="custom-control-input mgntp10" id="use2" value="hgHomeuse.use2" name="home_use"
          [(ngModel)]="hgHomeuse.use2" (ngModelChange)="getHome_use('Secondary / vacation home', hgHomeuse.use2)" />
        <label class="custom-control-label font20" for="use2">Secondary / vacation home</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use3">
        <input type="checkbox" class="custom-control-input mgntp10" id="use3" value="hgHomeuse.use3"
          name="home_use" [(ngModel)]="hgHomeuse.use3" (ngModelChange)="getHome_use('Work from home / home-based business', hgHomeuse.use3)" />
        <label class="custom-control-label font20" for="use3">Work from home / home-based business</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use4">
        <input type="checkbox" class="custom-control-input mgntp10" id="use4" value="hgHomeuse.use4" name="home_use"
          name="home_use" [(ngModel)]="hgHomeuse.use4" (ngModelChange)="getHome_use('Airbnb or occassional rental', hgHomeuse.use4)" />
        <label class="custom-control-label font20" for="use4">Airbnb or occassional rental</label>
      </label>
    </div>
    <p class="m-0 mb-2 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [disabled]="isDisable" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
    <div *ngIf="showTip">
      <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">DID YOU KNOW</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">DID YOU KNOW<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="use1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use1_mob" value="hgHomeuse.use1"
      name="home_use" [(ngModel)]="hgHomeuse.use1" (ngModelChange)="getHome_use('I live there (primary residence)', hgHomeuse.use1)" />
      <label class="custom-control-label font20" for="use1_mob">I live there (primary residence)</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use2_mob" value="hgHomeuse.use2" name="home_use"
      [(ngModel)]="hgHomeuse.use2" (ngModelChange)="getHome_use('Secondary / vacation home', hgHomeuse.use2)" />
      <label class="custom-control-label font20" for="use2_mob">Secondary / vacation home</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use3_mob" value="hgHomeuse.use3"
      name="home_use" [(ngModel)]="hgHomeuse.use3" (ngModelChange)="getHome_use('Work from home / home-based business', hgHomeuse.use3)" />
      <label class="custom-control-label font20" for="use3_mob">Work from home / home-based business</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use4_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use4_mob" value="hgHomeuse.use4" name="home_use"
      [(ngModel)]="hgHomeuse.use4" (ngModelChange)="getHome_use('Airbnb or occassional rental', hgHomeuse.use4)" />
      <label class="custom-control-label font20" for="use4_mob">Airbnb or occassional rental</label>
    </label>
    <!-- <div class="col-sm-10 text-left" *ngIf="showTyping">
        <img src="assets/images/typing-animated-gif-1.gif" />
      </div> -->
  </div>
  <div class="m-auto text-center">
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
  </div>
  <div class="col-sm-12 mx-auto mt-3 mb-2" *ngIf="showTip">
    <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
      <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
      <p class="text-center tiphead">DID YOU KNOW</p>
      <p class="text-center tipmes">{{questionObj.tip}}</p>
      <!-- <p class="text-center font-weight-bold">DID YOU KNOW<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
         <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active16.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active12.png"></span>
    <h5 class="clr333 processtxt">60% Completed</h5>
  </div>
</div> -->